import {$createParagraphNode, $getSelection, $isRangeSelection, LexicalEditor} from "lexical"
import {BannerType, INSERT_BANNER_COMMAND} from "../plugins/banner/banner-plugin"
import {$setBlocksType} from "@lexical/selection"

const debug = false
// const debug = "lexicalChangeBanner"

export function lexicalChangeBanner(editor: LexicalEditor, currentBockType: BannerType, value: BannerType) {
    debug && console.log(debug, 'process', currentBockType, value)

    editor.update(() => {
        const selection = $getSelection()
        if ($isRangeSelection(selection)) {
            $setBlocksType(selection, () => $createParagraphNode())
        }

        if (currentBockType !== value) editor.dispatchCommand(INSERT_BANNER_COMMAND, value)
    })
}